// Subscription system types
export interface UserProfile {
  id: string;
  clerk_user_id: string;
  email: string;
  first_name?: string;
  last_name?: string;
  company_name?: string;
  created_at: string;
  updated_at: string;
}

export interface SubscriptionPlan {
  id: string;
  name: string;
  display_name: string;
  description?: string;
  price_monthly?: number;
  price_yearly?: number;
  currency: string;
  features: Record<string, boolean>;
  limits: Record<string, any>;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface UserSubscription {
  id: string;
  user_id: string;
  plan_id: string;
  status: 'active' | 'canceled' | 'past_due' | 'unpaid';
  stripe_subscription_id?: string;
  stripe_customer_id?: string;
  current_period_start?: string;
  current_period_end?: string;
  cancel_at_period_end: boolean;
  created_at: string;
  updated_at: string;
}

export interface FeatureFlag {
  id: string;
  name: string;
  display_name: string;
  description?: string;
  is_enabled: boolean;
  created_at: string;
  updated_at: string;
}

export interface PlanFeature {
  id: string;
  plan_id: string;
  feature_id: string;
  is_enabled: boolean;
  limits: Record<string, any>;
  created_at: string;
}

export interface UsageMetric {
  id: string;
  user_id: string;
  metric_name: string;
  metric_value: number;
  period_start: string;
  period_end: string;
  created_at: string;
  updated_at: string;
}

export interface UserSubscriptionWithPlan extends UserSubscription {
  plan: SubscriptionPlan;
}

export interface FeatureAccess {
  feature: string;
  isEnabled: boolean;
  limits: Record<string, any>;
}

export interface SubscriptionStatus {
  currentPlan: SubscriptionPlan;
  subscription: UserSubscription;
  features: FeatureAccess[];
  usage: Record<string, number>;
  limits: Record<string, any>;
}

// Plan names as constants
export const PLAN_NAMES = {
  FREE: 'free',
  PRO: 'pro',
  ENTERPRISE: 'enterprise'
} as const;

export type PlanName = typeof PLAN_NAMES[keyof typeof PLAN_NAMES];

// Feature names as constants
export const FEATURE_NAMES = {
  REVIEWS: 'reviews',
  BASIC_ANALYTICS: 'basic_analytics',
  ADVANCED_ANALYTICS: 'advanced_analytics',
  EMAIL_NOTIFICATIONS: 'email_notifications',
  SLACK_INTEGRATION: 'slack_integration',
  CUSTOM_BRANDING: 'custom_branding',
  API_ACCESS: 'api_access',
  PRIORITY_SUPPORT: 'priority_support'
} as const;

export type FeatureName = typeof FEATURE_NAMES[keyof typeof FEATURE_NAMES];

// Usage metric names
export const USAGE_METRICS = {
  REVIEWS_CREATED: 'reviews_created',
  STORAGE_USED_GB: 'storage_used_gb',
  REVIEWERS_INVITED: 'reviewers_invited'
} as const;

export type UsageMetricName = typeof USAGE_METRICS[keyof typeof USAGE_METRICS]; 